var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"d-md-block bg-light sidebar d-none d-lg-table-cell"},[_c('div',{staticClass:"sidebar-sticky",staticStyle:{"border":"1px solid gray","border-radius":"5px","margin-top":"10px"}},[_c('adminMenu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }